import BtnQuiz from "./components/btnOpHome/btnQuiz";
import Header from "./components/header/header";
import ModalSelectLanguage from "./components/modals/select-language/modalSelectLanguage";
import I18n from "./i18n";
import PageHome from "./pages/home";
import PageInitial from "./pages/initial";

(function(app:HTMLElement){
    let modalSelectLanguage:ModalSelectLanguage;
    let headerElement:Header;
    let pageHome:PageHome;

    function main(){
        rederInitial();
    }

    function rederInitial(){
        
        let url_string = window.location.href;
        let url = new URL(url_string);
        let s = url.searchParams.get("s");

        resetApp();
        modalSelectLanguage = createModalSelectLanguage();

        let pageInitial = new PageInitial(app);
        pageInitial.render();
        pageInitial.addEventContinue(()=>{
            modalSelectLanguage.show();
        });
        I18n.exec();

        if(true){
            //headerElement = new Header(modalSelectLanguage,rederPageInitial);
            renderPageHome();
        }
        
    }

    function createModalSelectLanguage(){
        let modalSelectLnaguage = new ModalSelectLanguage(app.closest("body"))
        modalSelectLnaguage.render();
        modalSelectLnaguage.loadBody(()=>{
            headerElement = new Header(modalSelectLanguage,rederPageInitial);
            renderPageHome();
        });
        return modalSelectLnaguage;
    }

    function rederPageInitial(){
        resetApp();
        let pageInitial = new PageInitial(app);
        pageInitial.render();
        pageInitial.addEventContinue(()=>{
            modalSelectLanguage.show();
        });
        I18n.exec();
    }

    function renderPageHome(){
        resetApp();
        pageHome = new PageHome(app);
        pageHome.renderWithCB(()=>{
            //createBtnHistory();
            loadButtonOpHome();
        });
    
        headerElement.showHeader();
        I18n.exec();
    }

    function createBtnHistory(){
        let historyBtn = pageHome.renderBtnHistory();
        historyBtn.renderWithCB(()=>{
            historyBtn.openModalHistory();
        });
    }

    function loadButtonOpHome(){
        let arrayBtnOp = pageHome.renderBtnOptions();
        arrayBtnOp.forEach((btnOp)=>{
            btnOp.renderWithCB(()=>{
                btnOp.clickAction();
            });
            btnOp.actionClick();
        });
    }

    function resetApp(){
        app.innerHTML = "";
        if(modalSelectLanguage)modalSelectLanguage.onClose();
    }

    window.addEventListener("load",main);

})(document.querySelector("#app"));
